import { Route, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { PageHeaderComponent } from '@shared/lib/components/page-header/page-header.component';
import { RedirectComponent } from '@shared/lib/components/redirect/redirect.component';
import { MarketResolver } from '@usana/ux/markets/routing';
import { authenticatedSsoCanActivate } from '@usana/ux/sso-auth';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { SharedLoginConstants } from './shared-login.constants';

// this exists to list routes that will be used by both usana and baoying
export const calculateSharedRoutes: any = (childRoutes: Route[]): Routes => [
  { path: 'redirect', component: RedirectComponent },
  {
    path: ':marketId',
    resolve: {
      market: MarketResolver,
    },
    component: PageHeaderComponent,
    children: childRoutes.concat([
      {
        path: 'login',
        component: LoginPageComponent,
        data: { titleTag: 'formTitle', hideTitleTag: environment.app.isBaoying },
      },
      {
        path: 'login/:redirectUri',
        component: LoginPageComponent,
        data: { titleTag: 'formTitle', hideTitleTag: environment.app.isBaoying },
      },
      {
        path: 'masquerade',
        canActivate: [authenticatedSsoCanActivate],
        loadChildren: () =>
          import('@shared/lib/lazy-modules/masquerade/masquerade.module').then((m) => m.MasqueradeModule),
      },
      {
        path: 'info',
        canActivate: [authenticatedSsoCanActivate],
        loadChildren: () => import('@shared/lib/lazy-modules/info/info.module').then((m) => m.InfoModule),
      },
      {
        path: SharedLoginConstants.INTERRUPT_PATH,
        loadChildren: () =>
          import('@shared/lib/lazy-modules/interrupts/interrupt.module').then((m) => m.InterruptModule),
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: '**',
        loadChildren: () =>
          import('@shared/lib/lazy-modules/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
      },
    ]),
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
